exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/things/add/add.component.less
// module id = ../../../../../src/app/components/things/add/add.component.less
// module chunks = main